import React from 'react';
import { ISettlementItemForm } from '../../../../../types/order/fees/ICreateSettlementItemForm';
import { calculateMultiFeeTotal, calculateSingleFeeTotal } from './getFeeTotals';
import { NumberInput } from 'ui-toolkit';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';

export interface IFeesTotalFormProps {
  values: ISettlementItemForm;
  dirty: boolean;
}

export const FeesTotalForm: React.FC<IFeesTotalFormProps> = ({ values, dirty }) => {
  return (
    <div className={`flex flex-grow basis-5/12 flex-row`}>
      {values.statementFees.length > 1 && (
        <>
          <div className={'basis-1/5 p-1'}>
            <NumberInput
              name={`numericSettlementStatementPropertyValues.${eFeePropertyNames.BuyerPaidAtClosing}`}
              label="Buyer Paid"
              hintText={'At closing'}
              placeholder="$0.00"
              mode="currency"
              readOnly
              decimalScale={2}
              value={calculateMultiFeeTotal(
                values.statementFees,
                eFeePropertyNames.BuyerPaidAtClosing,
                values.numericSettlementStatementPropertyValues,
                dirty
              )}
            />
          </div>
          <div className={'basis-1/5 p-1'}>
            <NumberInput
              name={`numericSettlementStatementPropertyValues.${eFeePropertyNames.BuyerPaidBeforeClosing}`}
              hintText={'Before closing'}
              placeholder="$0.00"
              mode="currency"
              readOnly
              label={<div>&nbsp;</div>}
              wrapInput
              decimalScale={2}
              value={calculateMultiFeeTotal(
                values.statementFees,
                eFeePropertyNames.BuyerPaidBeforeClosing,
                values.numericSettlementStatementPropertyValues,
                dirty
              )}
            />
          </div>
          <div className={'basis-1/5 p-1'}>
            <NumberInput
              name={`numericSettlementStatementPropertyValues.${eFeePropertyNames.SellerPaidAtClosing}`}
              label={'Seller Paid'}
              hintText={'At closing'}
              placeholder="$0.00"
              mode="currency"
              readOnly
              decimalScale={2}
              value={calculateMultiFeeTotal(
                values.statementFees,
                eFeePropertyNames.SellerPaidAtClosing,
                values.numericSettlementStatementPropertyValues,
                dirty
              )}
            />
          </div>
          <div className={'basis-1/5 p-1'}>
            <NumberInput
              name={`numericSettlementStatementPropertyValues.${eFeePropertyNames.SellerPaidBeforeClosing}`}
              hintText={'Before closing'}
              placeholder="$0.00"
              mode="currency"
              readOnly
              label={<div>&nbsp;</div>}
              decimalScale={2}
              value={calculateMultiFeeTotal(
                values.statementFees,
                eFeePropertyNames.SellerPaidBeforeClosing,
                values.numericSettlementStatementPropertyValues,
                dirty
              )}
            />
          </div>
          <div className={'basis-1/5 p-1'}>
            <NumberInput
              name={`numericSettlementStatementPropertyValues.${eFeePropertyNames.OthersPaid}`}
              label={'Others Paid'}
              placeholder="$0.00"
              mode="currency"
              readOnly
              decimalScale={2}
              value={calculateMultiFeeTotal(
                values.statementFees,
                eFeePropertyNames.OthersPaid,
                values.numericSettlementStatementPropertyValues,
                dirty
              )}
            />
          </div>
        </>
      )}
      {values.statementFees.length === 1 && (
        <div className={'basis-80 p-1'}>
          <NumberInput
            name={'total'}
            label={'Settlement Statement Amount'}
            placeholder="$0.00"
            mode="currency"
            hintText={'This amount is the total of all fees within this settlement statement item.'}
            value={calculateSingleFeeTotal(
              values.statementFees[0],
              values.numericSettlementStatementPropertyValues,
              dirty
            )}
            decimalScale={2}
            readOnly
          />
        </div>
      )}
    </div>
  );
};
